import { Injectable } from '@angular/core';

import { Global } from '../../../app.global';

@Injectable()
export class PcnConst {

  public stageCCSent = 'CCSent';
  public stageOFRSent = 'OFRSent';
  public stageBailiffs = 'Bailiffs';

  constructor(public global: Global) { }

}
